export const RELATIONSHIP_TYPES = [
  'CHILD',
  'CHILD_IN_LAW',
  'SPOUSE_PARTNER',
  'PARENT',
  'GRANDCHILD',
  'SIBLING',
  'NIECE_NEPHEW',
  'COUSIN',
  'OTHER_FAMILY',
  'FRIEND',
  'PROFESSIONAL',
  'SELF',
];

export const RELATIONSHIP_ROLES = ['CARE_COORDINATOR', 'BILLING_CONTACT', 'DECISION_MAKER'];

// Loom's family member routes take the family_member id and the names separately, so the Family
// tab reads its own shape rather than the legacy relationships the other scenes share.
const fromRelationship = (relationship) => ({
  familyMemberId: relationship.familyMemberId,
  firstName: relationship.familyMember.person.firstName,
  lastName: relationship.familyMember.person.lastName,
  email: relationship.familyMember.person.email,
  phoneNumber: relationship.familyMember.person.phoneNumber,
  relationship: relationship.relationship,
  priority: relationship.priority,
  roles: relationship.roles.map((role) => role.role),
  editable: true,
  primary: false,
});

// Intake leads from before CQ-495 have a family member but no relationship. Loom edits members
// through their relationships, so these show without edit or remove.
const fromUnlinkedMember = (member) => ({
  familyMemberId: member.id,
  firstName: member.person.firstName,
  lastName: member.person.lastName,
  email: member.person.email,
  phoneNumber: member.person.phoneNumber,
  relationship: null,
  priority: null,
  roles: [],
  editable: false,
  primary: false,
});

const byPriority = (a, b) => (a.priority ?? Infinity) - (b.priority ?? Infinity);

// Loom refuses to remove the primary contact: the lowest priority, every member tied at it, and a
// missing priority ranking last. The tab marks the same members so it can hide their remove tool.
const markPrimary = (members) => {
  const ranked = members.filter((member) => member.priority !== null);
  const lowest = ranked.length ? Math.min(...ranked.map((member) => member.priority)) : null;

  return members.map((member) => ({...member, primary: member.priority === lowest}));
};

export const buildFamilyMembers = (client) => {
  if (client.relationships.length) {
    return markPrimary(client.relationships.map(fromRelationship)).sort(byPriority);
  }

  return client.family.members.map(fromUnlinkedMember);
};

export const toFamilyMemberBody = (form) => ({
  firstName: form.firstName,
  lastName: form.lastName,
  email: form.email || null,
  phoneNumber: form.phoneNumber || null,
  relationship: form.relationship,
  priority: form.priority === '' ? null : Number(form.priority),
  roles: form.roles,
});
